import React, { useEffect, useState } from 'react'
import { searchAttriutes } from '../../services/attributeService'
import { getFeatureIds } from './itemDecorator'

function collectFeatureIds(products: any): string[] | null {
  if (!products) return null
  const fids = Object.keys(products)
    .map(pKey => getFeatureIds(products[pKey]))
    .filter(fids => fids !== null && fids !== undefined)
    .flat(1)
  const idSet = new Set<string>(fids as string[])
  return Array.from(idSet)
}

function getNamedFeatures(product, featureMapping) {
  if (!product) return null
  const featureIds = getFeatureIds(product)
  if (!Array.isArray(featureIds)) return null
  return featureIds.map(id => {
    if (featureMapping?.[id]) {
      return featureMapping[id].value
    }
    // fallback for mismatch
    return id
  })
}

// feature id <-> attribute name mapping
function useFeatureMapping(products: any, enabled: boolean): { [id: string]: any } {
  const [features, setFeatures] = useState<any>(null)
  useEffect(() => {
    if (!enabled) return
    const ids = collectFeatureIds(products)
    if (!ids?.length) return
    searchAttriutes(ids)
      .then(res => {
        if (Array.isArray(res.data.items)) {
          const mapping = {}
          res.data.items.forEach(item => {
            mapping[item.id] = item
          })
          setFeatures(mapping)
        }
      })
  }, [products, enabled])
  return features
}

export { collectFeatureIds, getNamedFeatures }
export default useFeatureMapping
